export const iconFontAwesomeHumanitarianTarpDroplet = (
	<i className="fa-solid fa-tarp-droplet"></i>
);
